import { DeviceInfoModel } from './DeviceInfoModel';

export class UserNewPasswordModel extends DeviceInfoModel
{
    Pin:string;
    NewPassword:string;
}